import { render, staticRenderFns } from "./mange.vue?vue&type=template&id=52df2a0f&scoped=true"
import script from "./mange.vue?vue&type=script&lang=js"
export * from "./mange.vue?vue&type=script&lang=js"
import style0 from "./mange.vue?vue&type=style&index=0&id=52df2a0f&prod&lang=less"
import style1 from "./mange.vue?vue&type=style&index=1&id=52df2a0f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df2a0f",
  null
  
)

export default component.exports